export default __webpack_public_path__ + "static/media/char-luke.9267c52b.jpg";